// Color Scheme

import { ALPHA_200, ALPHA_400, ALPHA_500 } from '@/mui/constants/opacity';

export const COMMON = {
  black: '#000',
  white: '#fff',
};

export const ACTIONS_OPACITY = {
  disabledOpacity: ALPHA_500,
  disabledBackgroundOpacity: ALPHA_200,
  hoverOpacity: ALPHA_200,
  selectedOpacity: ALPHA_400,
  focusOpacity: ALPHA_400,
  activatedOpacity: ALPHA_400,
};

export const colorList = [
  'primary',
  'secondary',
  'info',
  'success',
  'warning',
  'error',
  'highlight',
  'highlight2',
  'complimentary',
] as const;

export const colorPaletteComponentList = [...colorList, 'neutral'] as const;
